import { cartDetailsFragment } from '../queries/get-cart-query'

const cartCreateMutation = /* GraphQL */ `
  mutation cartCreate($input: CartInput) {
    cartCreate(input: $input) {
      userErrors {
        code
        field
        message
      }
      cart {
        ...cartDetails
      }
    }
  }

  ${cartDetailsFragment}
`
export default cartCreateMutation
